module.exports = __webpack_public_path__ + "359f38df04e404560b00f3543939b22e.svg";